import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Heading, TextStyle} from '@shopify/polaris';
import Select from './options/select';
import Checkbox from './options/checkbox';
import Radio from './options/radio';
import TextArea from './options/textarea';
import TextField from './options/textfield';
import Files from './options/files';
import store from '../../store';

class Question extends React.Component {
  constructor(props) {
    super(props);

    this.renderInput = this.renderInput.bind(this);
  }

  render() {
    const {question} = this.props;
    const {inputs} = question;
    return (
      <section className="sm-question">
        {renderHeader(question.title, question.description)}
        <div className="sm-question__inputs">
          {inputs.map(this.renderInput)}
        </div>
      </section>
    );
  }

  renderInput(inputId) {
    const {
      entities: {inputs},
    } = store.getState();
    const {question} = this.props;
    const input = inputs[inputId];

    switch (input.type) {
      case 'select': {
        return (
          <section className="sm-question__input" key={inputId}>
            <Select inputId={inputId} questionId={question.handle} />
          </section>
        );
      }

      case 'checkbox': {
        return (
          <section className="sm-question__input" key={inputId}>
            <Checkbox inputId={inputId} questionId={question.handle} />
          </section>
        );
      }

      case 'radio': {
        return (
          <section className="sm-question__input" key={inputId}>
            <Radio inputId={inputId} questionId={question.handle} />
          </section>
        );
      }

      case 'textarea': {
        return (
          <section className="sm-question__input" key={inputId}>
            <TextArea inputId={inputId} questionId={question.handle} />
          </section>
        );
      }

      case 'files': {
        return (
          <section className="sm-question__input" key={inputId}>
            <Files inputId={inputId} questionId={question.handle} />
          </section>
        );
      }

      case 'text':
      case 'email':
      case 'password':
      case 'number':
      case 'tel':
      case 'url':
      case 'date':
      case 'datetime-local':
      case 'month':
      case 'week':
      case 'time': {
        return (
          <section className="sm-question__input" key={inputId}>
            <TextField
              key={inputId}
              inputId={inputId}
              questionId={question.handle}
            />
          </section>
        );
      }

      default: {
        return null;
      }
    }
  }
}

function renderHeader(title, description) {
  const content = (
    <header className="sm-question__header">
      {renderTitle(title)}
      {renderDescription(description)}
    </header>
  );
  return title || description ? content : null;
}

function renderTitle(title) {
  return title ? <Heading>{title}</Heading> : null;
}

function renderDescription(description) {
  return description ? (
    <TextStyle variation="subdued">{description}</TextStyle>
  ) : null;
}

function mapStateToProps(state, ownProps) {
  const question = state.entities.questions[ownProps.questionId];

  return {
    question,
  };
}

export default connect(mapStateToProps)(Question);

Question.propTypes = {
  questionId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  question: PropTypes.object.isRequired,
};
